{
  "title": "Urgent town-wide alerts",
  "lead": "For emergencies and disruptions everyone must know about now. An alert reaches every resident, whatever they follow, and leads the home feed.",
  "notAllowed": "This office can't send town-wide urgent alerts. Ask the LGU administrator if it should.",
  "viewerNote": "You can see the alerts this office sent. Editors and office heads can send new ones.",
  "ordinaryNote": "Not urgent? Post an ordinary announcement instead; it reaches the people who follow your office.",
  "composeTitle": "New urgent alert",
  "alertTitle": "Headline",
  "alertTitleHint": "Short and clear, e.g. \"Classes suspended tomorrow, all levels\".",
  "message": "Message",
  "messageHint": "What people must know or do. Keep it short so the text message fits.",
  "smsCount": "{chars} characters · {parts} SMS",
  "smsUnicode": "Some characters make each SMS shorter (70 instead of 160). Avoid emoji and curly quotes.",
  "smsLong": "Text messages are cut after 3 SMS. Shorten the message if you can.",
  "link": "Link to a post with the details",
  "linkNone": "No link",
  "linkHint": "For example the full advisory. Lists this office's published posts.",
  "duration": "Keep it at the top of the feed for",
  "duration_6": "6 hours",
  "duration_24": "24 hours",
  "duration_72": "3 days",
  "duration_none": "Until an editor archives it",
  "channels": "How it goes out",
  "channelPush": "App notification to every resident",
  "channelPushHint": "{residents} residents · {devices} phones with notifications on",
  "channelPushOff": "Phone notifications aren't set up yet. Residents will see the alert in the app and in their inbox.",
  "channelSms": "Also send a text message (SMS)",
  "channelSmsHint": "To {count} residents with a mobile number who haven't turned SMS alerts off. Each text message costs the LGU.",
  "smsNotConfigured": "SMS is not set up (SEMAPHORE_API_KEY), so no text messages will be sent. The app notification still goes out.",
  "review": "Review and send",
  "reviewTitle": "Send this urgent alert?",
  "reviewReach": "It goes to {residents} residents now and stays at the top of the home feed.",
  "reviewSms": "A text message will go to {count} mobile numbers.",
  "reviewNoSms": "No text message will be sent.",
  "smsPreview": "Text message",
  "pushPreview": "App notification",
  "confirmSms": "I understand that {count} text messages will be sent and can't be recalled.",
  "send": "Send alert now",
  "sending": "Sending…",
  "back": "Back to editing",
  "sent": "Alert sent to {residents} residents.",
  "sentSms": "Alert sent. Text messages are going out to {count} numbers.",
  "historyTitle": "Sent alerts",
  "historyEmpty": "No urgent alerts sent yet.",
  "sentBy": "Sent {date} by {name}",
  "sentAt": "Sent {date}",
  "reach": "{count} residents notified",
  "pushed": "{count} phones",
  "smsSent": "{count} SMS sent",
  "smsFailed": "{count} SMS failed",
  "smsNotSent": "SMS not set up: {count} not sent",
  "delivering": "Still sending…",
  "active": "Top of the feed",
  "until": "until {date}",
  "ended": "No longer at the top",
  "viewPost": "View",
  "editPost": "Edit or archive",
  "urgent": "Urgent",
  "titleRequired": "Write a headline of at least 5 characters.",
  "messageRequired": "Write a message of at least 10 characters.",
  "sentNoSms": "SMS is not set up, so no text messages were sent."
}
